@switch (state()) {
  @case ('blank') {
    <!-- Nothing open: on the panel's middle line, level with panels 2 and 3's empty states (Johanna, 2026-10-21). -->
    <app-no-content-stub data-test="kp-results-blank" [imageSrc]="image()">
      <p class="text-base font-medium text-gray-900 text-center">Select an item to see related {{ noun() }}</p>
    </app-no-content-stub>
  }
  @case ('idle') {
    <app-no-content-stub data-test="kp-results-idle" class="px-12 text-center" anchor="box" [imageSrc]="image()">
      <!-- stitch-app-shell skin's idle copy (Johanna, 2026-10-19), keeping the multi-select hint. -->
      <div class="flex max-w-112 flex-col gap-2">
        <p class="text-base font-medium text-gray-900">Select a knot, tag or connection</p>
        <p class="text-sm text-gray-600">Related {{ noun() }} will show up here</p>
      </div>
      <span class="rounded-md bg-gray-100 px-3 py-1 text-sm text-gray-700">Hold ⌘ / Ctrl to select multiple</span>
    </app-no-content-stub>
  }
  @case ('none') {
    <app-no-content-stub data-test="kp-results-none" anchor="box" [imageSrc]="image()">
      <p class="text-base font-medium text-gray-900 text-center">No related {{ noun() }}</p>
    </app-no-content-stub>
  }
}
